import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class LanguageService {
    public static readonly LANGUAGE_STORAGE_KEY = 'salespoint.i18.lang';
    public static readonly AVAILABLE_LANGUAGES = ['pl', 'en', 'gr'];

    private lang = localStorage.getItem(LanguageService.LANGUAGE_STORAGE_KEY) === null
        ? LanguageService.AVAILABLE_LANGUAGES[0]
        : localStorage.getItem(LanguageService.LANGUAGE_STORAGE_KEY);

    constructor(private translate: TranslateService) {
    }

    use(lang: string) {
        if (LanguageService.AVAILABLE_LANGUAGES.indexOf(lang.toLowerCase()) === -1) {
            return false;
        }
        this.lang = lang;
        this.translate.use(this.lang);
        localStorage.setItem(LanguageService.LANGUAGE_STORAGE_KEY, this.lang);
        return true;
    }

    getCurrent() {
        return this.lang;
    }

    getMaterialLanguageCode() {
        const map = {
            gr: 'el'
        };
        return this.lang in map
            ? map[this.lang]
            : this.lang;
    }
}
